<input class="file-input" type="file" [disabled]="disabled">
